// =====================================================
// ROUTE -> FRIENDLY PAGE NAME  (Admin Activity Dashboard)
// A single source of truth that turns an app route into a human-readable page
// label ("Create Blog", "Author Profile", ...). Shared by the activity tracker
// (what it reports) and the dashboard (what it displays), so the two never
// drift apart. Falls back gracefully for unknown / dynamic routes.
// =====================================================

// Exact-match routes.
const EXACT = {
  "/": "Login",
  "/home": "Dashboard",
  "/register": "Register",
  "/chat": "Chat",
  "/notify": "Notifications",
  "/blogs": "Blogs",
  "/add-blog": "Create Blog",
  "/pro": "Profile",
  "/leaderboard": "Leaderboard",
  "/save": "Saved Blogs",
  "/set": "Settings",
  "/streak": "Streak",
  "/admin": "Admin",
  "/activity": "Activity Dashboard",
  "/upload-status": "Upload Status",
  "/view-status": "View Status",
  "/ads": "Ads",
  "/ad": "Advertise",
  "/sub": "Submit Ad",
  "/today": "Best Blogger Today",
  "/ana": "Ads Analytics",
  "/re": "Reward Admin",
  "/adminlove": "Love Admin",
  "/lovelist": "Love List",
  "/lo": "Love",
  "/pr": "Reward Proof",
  "/terms": "Terms",
  "/privacy": "Privacy",
};

// Prefix-match routes (dynamic segments).
const PREFIX = [
  { test: "/blog/", name: "Read Blog" },
  { test: "/authorprofile/", name: "Author Profile" },
];

export function getPageName(pathname) {
  if (!pathname) return "Unknown";
  if (EXACT[pathname]) return EXACT[pathname];

  for (const p of PREFIX) {
    if (pathname.startsWith(p.test)) return p.name;
  }

  // Fallback: prettify the first path segment ("/foo-bar" -> "Foo Bar").
  const seg = pathname.split("/").filter(Boolean)[0];
  if (!seg) return "Home";
  return seg
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default getPageName;
